import type { Wallet } from '@klaro7/shared-types';

/**
 * Taglio di ricarica evidenziato come "Più conveniente" nelle superfici di
 * ricarica: 30€ (+20 bonus = 50€ di credito). È la migliore leva prova +
 * fidelizzazione (~50 min a 0,99 €/min). Solo evidenziazione visiva: importi e
 * logica bonus restano invariati (vedi RECHARGE_PACKAGES in shared-types).
 */
export const RECOMMENDED_RECHARGE_AMOUNT = 30;

/**
 * True once the user has completed at least one recharge. The "Bonus Prima
 * Ricarica" (Art. 6.8) is a one-time offer, so every promo/bonus display tied
 * to it must disappear from this point on. A missing/not-yet-loaded wallet
 * counts as "not recharged".
 */
export function hasCompletedFirstRecharge(
  wallet: Wallet | null | undefined,
): boolean {
  return (wallet?.rechargeCount ?? 0) >= 1;
}

/**
 * The first-recharge offer (0,99 €/min promo price, 7-minute bonus, bonus
 * recharge packages) is shown to anonymous visitors and to logged-in users who
 * have not recharged yet. It disappears once the user completes a recharge.
 */
export function isFirstRechargeOfferEligible(
  isAuthenticated: boolean,
  wallet: Wallet | null | undefined,
): boolean {
  if (!isAuthenticated) return true;
  return !hasCompletedFirstRecharge(wallet);
}
